<template>
  <div class="summary-bar d-flex align-center flex-wrap mt-3 mb-3">
    <div class="summary-pill d-flex align-center">
      <v-icon color="primary" small class="mr-2">mdi-calendar</v-icon>
      <span class="font-weight-bold">{{ formatDate(date) }}</span>
    </div>
    <div class="summary-pill summary-stat">
      <span class="font-weight-bold">{{ summary.count }}</span>
      <span class="grey--text summary-label">{{ $t("orders") }}</span>
    </div>
    <div class="summary-pill summary-stat">
      <span class="font-weight-bold"> {{ summary.revenue.toFixed(2) }} {{ currency }} </span>
      <span class="grey--text summary-label">{{ $t("total") }}</span>
    </div>
    <div class="d-flex flex-wrap summary-breakdown">
      <v-chip
        v-for="b in summary.breakdown"
        :key="b.state"
        small
        :style="statusChipStyle(b.state)"
        class="font-weight-medium mr-2"
      >
        <span class="status-dot mr-1" :style="statusDotStyle(b.state)"></span>
        {{ b.count }} {{ $t(b.state) }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import hasGuestOrderStatus from "@/mixins/report/hasGuestOrderStatus";

export default {
  name: "ReportTableSummaryBar",
  mixins: [hasGuestOrderStatus],
  props: {
    date: {
      type: String,
      required: true,
    },
    dateData: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: "",
    },
  },
  computed: {
    summary() {
      const counts = {};
      let revenue = 0;
      (this.dateData || []).forEach((item) => {
        revenue += this.calculateTotal(item);
        const order = item.orders_guest && item.orders_guest[0];
        if (order) {
          counts[order.state] = (counts[order.state] || 0) + 1;
        }
      });
      const breakdown = Object.entries(counts).map(([state, count]) => ({
        state,
        count,
      }));
      return { count: (this.dateData || []).length, revenue, breakdown };
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("sr-Latn", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
};
</script>

<style scoped>
.summary-bar {
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #e1dfda;
  border-radius: 6px;
  gap: 10px;
}

.summary-pill {
  background: #f5f4f2;
  border: 1px solid #eae7e2;
  border-radius: 8px;
  padding: 6px 14px;
}

.summary-stat {
  display: flex;
  align-items: baseline;
  gap: 6px;
  white-space: nowrap;
}

.summary-label {
  font-size: 12.5px;
}

.summary-breakdown {
  margin-left: auto;
}

.status-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
</style>
